import React from "react";
import { Link } from "react-router-dom";
import CONSTANT from "./../../constant";
import Loader from "./../../component/common/Loader";
import { addAppraisalCycle } from "../../actions/AppraisalCycleAction";

class AddAppraisalCycle extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      isMouApplicable: { name: "isMouApplicable", value: "", error: "" },
      cycleName: { name: "cycleName", value: "", error: "" },
      financialYear: { name: "financialYear", value: "", error: "" },
      startDate: { name: "startDate", value: "", error: "" },
      endDate: { name: "endDate", value: "", error: "" },
      status: { name: "status", value: "Draft", error: "" },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title =
      "Create Appraisal Cycle - " + CONSTANT.organisation.name;
  }

  render() {
    const {
      isMouApplicable,
      cycleName,
      financialYear,
      startDate,
      endDate,
      status,
      showLoader,
    } = this.state;

    const mouYes = isMouApplicable.value === "true";
    const mouSelected = isMouApplicable.value !== "";

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-12">
                    <h1 className="page-title">
                      Create Appraisal Cycle
                    </h1>
                  </div>
                </div>

                <form onSubmit={this.onSubmit}>
                  {/* MoU Section */}
                  <div className="row mb-2">
                    <div className="col-md-12">
                      <h5 className="text-muted">
                        <i className="fa fa-balance-scale mr-2" />
                        MoU & Weightage
                      </h5>
                      <hr />
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          Is MoU Applicable?{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className={
                            isMouApplicable.error
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name={isMouApplicable.name}
                          value={isMouApplicable.value}
                          onChange={this.onChange}
                        >
                          <option value="">Select</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                        {isMouApplicable.error && (
                          <div className="invalid-feedback">
                            {isMouApplicable.error}
                          </div>
                        )}
                      </div>
                    </div>

                    {mouSelected && (
                      <div className="col-md-9">
                        <div
                          className={`alert mb-0 ${
                            mouYes ? "alert-info" : "alert-warning"
                          }`}
                        >
                          {mouYes
                            ? "Weightage: 20% MoU + 55% KPAs"
                            : "Weightage: 75% KPAs only"}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Basic Details */}
                  <div className="row mb-2 mt-4">
                    <div className="col-md-12">
                      <h5 className="text-muted">
                        <i className="fa fa-info-circle mr-2" />
                        Basic Details
                      </h5>
                      <hr />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Cycle Name{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={
                            cycleName.error
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name={cycleName.name}
                          value={cycleName.value}
                          onChange={this.onChange}
                        />
                        {cycleName.error && (
                          <div className="invalid-feedback">
                            {cycleName.error}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Appraisal Cycle Year{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className={
                            financialYear.error
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name={financialYear.name}
                          value={financialYear.value}
                          onChange={this.onChange}
                        >
                          <option value="">Select</option>
                          {(() => {
                            const now = new Date();
                            const currentFYStart = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
                            // Wider range for testing multiple cycles: 2 future FYs down to 7 past FYs.
                            const years = [];
                            for (let y = currentFYStart + 2; y >= currentFYStart - 7; y--) {
                              years.push(y);
                            }
                            return years.map((year) => {
                              const fy = `${year}-${String(year + 1).slice(2)}`;
                              return <option key={fy} value={fy}>{fy}</option>;
                            });
                          })()}
                        </select>
                        {financialYear.error && (
                          <div className="invalid-feedback">
                            {financialYear.error}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          className="form-control"
                          name={status.name}
                          value={status.value}
                          onChange={this.onChange}
                        >
                          <option value="Draft">Draft</option>
                          <option value="Active">Active</option>
                          <option value="Completed">Completed</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Dates */}
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Start Date{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={
                            startDate.error
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name={startDate.name}
                          value={startDate.value}
                          onChange={this.onChange}
                        />
                        {startDate.error && (
                          <div className="invalid-feedback">
                            {startDate.error}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          End Date{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={
                            endDate.error
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name={endDate.name}
                          value={endDate.value}
                          onChange={this.onChange}
                        />
                        {endDate.error && (
                          <div className="invalid-feedback">
                            {endDate.error}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="row mt-4">
                    <div className="col-md-3">
                      <Link
                        to={CONSTANT.component.startAppraisalCycle.url}
                        className="btn btn-block cancel-button btn-sm"
                      >
                        Cancel
                      </Link>
                    </div>
                    <div className="col-md-6" />
                    <div className="col-md-3">
                      <button
                        type="submit"
                        className="btn btn-block submit-button btn-sm"
                      >
                        Create Cycle
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {showLoader && <Loader />}
      </div>
    );
  }

  onChange = (e: any) => {
    const { name, value } = e.target;
    this.setState((prev: any) => ({
      [name]: { ...prev[name], value, error: "" },
    }));
  };

  validateForm = () => {
    const { isMouApplicable, cycleName, financialYear, startDate, endDate } =
      this.state;

    let isValid = true;

    if (!isMouApplicable.value) {
      this.setState((p: any) => ({
        isMouApplicable: {
          ...p.isMouApplicable,
          error: "Please select MoU applicability",
        },
      }));
      isValid = false;
    }

    if (!cycleName.value.trim()) {
      this.setState((p: any) => ({
        cycleName: {
          ...p.cycleName,
          error: "Cycle name is required",
        },
      }));
      isValid = false;
    }

    if (!financialYear.value) {
      this.setState((p: any) => ({
        financialYear: {
          ...p.financialYear,
          error: "Financial year is required",
        },
      }));
      isValid = false;
    }

    if (!startDate.value) {
      this.setState((p: any) => ({
        startDate: {
          ...p.startDate,
          error: "Start date is required",
        },
      }));
      isValid = false;
    }

    if (!endDate.value) {
      this.setState((p: any) => ({
        endDate: {
          ...p.endDate,
          error: "End date is required",
        },
      }));
      isValid = false;
    }

    if (startDate.value && endDate.value && startDate.value >= endDate.value) {
      this.setState((p: any) => ({
        endDate: {
          ...p.endDate,
          error: "End date must be after start date",
        },
      }));
      isValid = false;
    }

    return isValid;
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    this.setState({ showLoader: true });

    const st = this.state;

    const model = {
      isMouApplicable: st.isMouApplicable.value === "true",
      cycleName: st.cycleName.value,
      financialYear: st.financialYear.value,
      startDate: st.startDate.value,
      endDate: st.endDate.value,
      status: st.status.value,
    };

    addAppraisalCycle(model).then((res: any) => {
      this.setState({ showLoader: false });

      if (res.status === CONSTANT.static.apiStatus.success) {
        alert("Appraisal Cycle created successfully!");
        this.props.history.push(
          CONSTANT.component.startAppraisalCycle.url
        );
      } else {
        alert(res.error || "Failed to create cycle");
      }
    });
  };
}

export default AddAppraisalCycle;